import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-exercise-intro',
    templateUrl: './exercise-intro.component.html',
    styleUrls: ['./exercise-intro.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class ExerciseIntroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
